// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ambipom: PokeData = {
  "id": 424,
  "name": "ambipom",
  "height": 12,
  "weight": 203,
  "base_experience": 169,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "double-edge",
    "tail-whip",
    "agility",
    "quick-attack",
    "screech",
    "swift",
    "fury-swipes",
    "baton-pass",
    "iron-tail",
    "astonish",
    "tickle",
    "fling",
    "last-resort",
    "nasty-plot",
    "mud-bomb",
    "double-hit",
    "dual-chop"
  ],
  "moves": [
    "scratch",
    "agility",
    "quick-attack",
    "mud-bomb",
    "purification",
    "tackle",
    "body-slam",
    "scary-face",
    "tri-attack",
    "growl",
    "splash",
    "supersonic",
    "leer"
  ],
  "evolution_chain": {
    "id": 93,
    "item": null,
    "species": [
      {
        "name": "aipom",
        "order": 219,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ambipom",
        "order": 220,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 190,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "double-hit"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 161,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
